import React from 'react';
import propTypes from 'prop-types';
import CommentReplyItem from './CommentReplyItem';

export default function CommentReplies({ replies }) {
  return (
    <div>
      {replies.map((reply, key) => (
        // eslint-disable-next-line react/no-array-index-key
        <CommentReplyItem reply={reply} key={`reply-${key}`} />
      ))}
    </div>
  );
}
CommentReplies.propTypes = {
  replies: propTypes.array,
};

CommentReplies.defaultProps = {
  replies: [
    { text: 'não concordo', user: { name: 'junior' } },
    { text: 'não concordo', user: { name: 'junior' } },
  ],
};
